import { Component } from '@angular/core';
import { AppLang } from '@enums/enum';
import { TranslateService } from '@ngx-translate/core';
@Component({
    selector: 'app-root',
    template: `
    <router-outlet></router-outlet>`
})
export class AppComponent {
    constructor(private translateService: TranslateService) {
        const lang = localStorage.getItem('lang') || AppLang.PL;
        this.translateService.setDefaultLang(lang);
        this.translateService.use(lang);
        
        // Zapisz returnUrl jeśli użytkownik nie jest zalogowany i nie jest na stronie logowania
        this.captureReturnUrl();
    }
    
    private captureReturnUrl() {
        const currentPath = window.location.pathname + window.location.search;
        const isLoggedIn = !!localStorage.getItem('user');
        
        if (!isLoggedIn && currentPath && currentPath !== '/' && !currentPath.includes('/login')) {
            sessionStorage.setItem('returnUrl', currentPath);
        }
    }

    // public spinkit = Spinkit;
}
